<!--  -->
<template>

  <page pageDataUrl="/api/pageData/page_product"
        v-on:paddingData="paddingPageData"
        :hasbreadcrumbs="true"
        defPageTitle="产品介绍">

    <div class='content'>
      <h1 class="entry-title">产品介绍</h1>
      <div class="product-introduce">
        {{product}}
      </div>

      <div class="product-group">

        <div class="product-class-item"
             v-for="(item, index) in pgs"
             :key="index">
          <div class="top-ProductItem">
            <router-link :to="{path:'units/'+item.pGLink}">
              <h1>
                {{item.pGName}}
              </h1>
            </router-link>
            <h2>
              {{item.pGEnglishTitle}}
            </h2>
          </div>
          <p class="middle-productItem">
            {{item.pGFTitle}}
          </p>
          <div class="bottom-productItem">
            <ul>
              <li v-for="(p,pindex) in item.ps">

                <router-link :to="{path:'units/'+item.pGLink+'/'+p.pLink}"> {{p.pName}}</router-link>
              </li>
            </ul>
          </div>
          <img :src="item.pGPic" />
        </div>

      </div>

      <easySearch></easySearch>

    </div>
  </page>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      product: "",
      pgs: [],
      searchForm: {}
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    paddingPageData(data) {
      this.pgs = data.data.pgs;
      this.product = data.data.product;
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    // var that = this;
    // this.$request.get({
    //   url: "/api/pageData/page_product",
    //   callback: {
    //     success: function (data) {
    //       that.pgs = data.data.pgs
    //       that.product = data.data.product
    //     },
    //     err: function (err) {
    //       console.log(err);
    //     }
    //   }
    // });
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
@import url("../../../assets/css/all.css");
</style>